import Validators from '@/classes/Validators';
import moment from "moment";
export const VALIDATION_RULES = {
    REQUIRED: ((value) => value === 0
        || !!value
        || 'Tato položka je povinná'),
    NUMBER: ((value) => !isNaN(Number(value))
        || 'Tato položka musí být číslo'),
    EMAIL: ((value) => Validators.isEmail(String(value))
        || 'Tato položka musí být email'),
    POSITIVE_NUMBER: ((value) => (!isNaN(Number(value)) && Number(value) > 0)
        || 'Tato položka musí být kladné číslo'),
    UNSIGNED_NUMBER: ((value) => (!isNaN(Number(value)) && Number(value) >= 0)
        || 'Tato položka musí být kladné číslo nebo 0'),
    DATE_AFTER: ((value) => (typeof value === 'string' && moment(value, 'YYYY-MM-DD').isAfter(moment()))
        || 'Vybrat můžete pouze budoucí datum'),
    VALID_DATE: ((value) => (typeof value === 'string' && moment(value, 'YYYY-MM-DD', true).isValid())
        || 'Neplatné datum'),
    IMAGE: ((value) => !value
        || ['jpg', 'png', 'gif'].includes(value?.name?.split('.').pop() ?? '')
        || 'Nahraný soubor není obrázek v podporovaném formátu'),
    NOT_SAME_AS: (compare) => (value) => value !== compare
        || 'Nelze vybrat tuto hodnotu',
    PHONE_NUMBER: ((value) => value === ''
        || new RegExp('^(\\+420)?\\s?[0-9]{3}\\s?[0-9]{3}\\s?[0-9]{3}$').test(String(value))
        || 'Telefonní číslo je ve špatném formátu'),
    BIRTH_NUMBER: ((value) => Validators.isBirthNumber(String(value ?? ''))
        || 'Rodné číslo je ve špatném formátu'),
    ICO: ((value) => Validators.isIco(String(value ?? ''))
        || 'IČO je ve špatném formátu'),
    BANK_ACCOUNT: ((value) => value === ''
        || new RegExp('^([0-9]{1,6}\\-)?[0-9]{8,10}\\/[0-9]{4}$').test(String(value))
        || 'Číslo účtu je ve špatném formátu'),
};
